import { BigNumber } from 'bignumber.js';

export const LOSS_LIMIT = BigNumber(5);
